<div class="main-container">
  <div style="padding: 12px; height: 128px; flex-direction: row; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: baseline; flex: 1 1 0%;">
  </div>
  <lex-bates-range-select [productionJobs]="productionJobs" [isCreateMode]="true" (selectedRangeEvent)="selectedRangeEvent($event)"
                          style="width: 100%; height: 100%; overflow: auto;"></lex-bates-range-select>

  <div style="display: flex; justify-content: end; margin-top: 16px">
    <button mat-raised-button color="primary" id="createNewProduction" (click)="startNewPrefix()">Create New Production</button>
  </div>
</div>
